function addToCart(e) {
  e.preventDefault();

  const productId = this.dataset.productId;
  const formData = new FormData();

  this.classList.add('loading');
  this.disabled = true;

  formData.append('action', 'add_to_cart_ajax');
  formData.append('product_id', productId);
  formData.append('quantity', 1);
  formData.append('nonce', wpbuoy_ajax.nonce);

  fetch(wpbuoy_ajax.ajax_url, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    this.classList.remove('loading');
    this.disabled = false;

    if (data.success) {
      // Update cart counter
      const cartCounter = document.querySelector('.cart-counter');
      if (cartCounter && data.data.cart_count !== undefined) {
        cartCounter.setAttribute('data-count', data.data.cart_count);
        cartCounter.textContent = data.data.cart_count > 0 ? data.data.cart_count : '';
        
        // Add shake animation
        cartCounter.classList.add('shake');
        
        // Remove shake class after animation completes
        setTimeout(() => {
          cartCounter.classList.remove('shake');
        }, 1000);
      }
    } else {
      console.error('Error:', data.message);
    }
  })
  .catch(error => {
    this.classList.remove('loading');
    this.disabled = false;

    console.error('Error:', error);
  });
}

const addToCarts = document.querySelectorAll('.add-to-cart');
if (addToCarts) {
  addToCarts.forEach(addToCart => {
    addToCart.addEventListener('click', addToCart);
  });
}